import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';

const centerUrl = `${baseGrtURL}/api/grt-user-center-service`;

export const url = {
    feedback: `${centerUrl}/open/agent/feedback` //反馈
};
//获取课件详情
export function handleSaveFeedBack(data) {
    return hMacAjax.post(url.feedback, data);
}
